// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0c48e2ab","335":"76bc1837","394":"137ca216","459":"6adb10ad","525":"f998091b","544":"e707da82","580":"aa6f957a"}[chunkId] + ".chunk.js";
};